import React from "react";
import { Link } from '../../../plugins/gatsby-plugin-atollon';
import ProductCard from '../cards/product';

const ProductRelated = ({ brand, related }) => {

  if (related?.length === 0) return

  return (
    <section className={`product-archive ${brand} product-archive--related`}>
      <div className='product-archive__inner'>
        <h3>More quality products</h3>
        <div className='product-archive__items'>
          {
            related?.length > 0 && related.map((el, i) => (
              <Link to={el.permalink} key={i} className='product-archive__item'>
                <ProductCard {...el} />
              </Link>
            ))
          }
        </div>
      </div>
    </section>
  )
}

export default ProductRelated